/**
 |--------------------------------------------------------------------------
 | ORDERS : Vue-Router Routes
 |--------------------------------------------------------------------------
 */
const orders = [
  {
    path: '/orders/all', component: require('pages/orders/all.vue').default,
    name: 'all_orders',
    meta: {requiresAuth: true, title: "All Orders", icon: "fas fa-list-alt"}
  }, {
    path: '/orders/assignment', component: require('pages/orders/assignment.vue').default,
    name: 'order_assignment',
    meta: {requiresAuth: true, title: "New Assignment", icon: "fas fa-street-view"}
  }, {
    path: '/orders/assign_all', component: require('pages/orders/order_assign_all.vue').default,
    name: 'order_assign_all',
    meta: {requiresAuth: true, title: "Assign all to order", icon: "fas fa-people-arrows"}
  }, {
    path: '/orders/all/live', component: require('pages/orders/all_live.vue').default,
    name: 'all_live_orders',
    meta: {requiresAuth: true, title: "All live orders", icon: "fas fa-tasks"}
  }, {
    path: '/orders/all/expiring', component: require('pages/orders/all_expiring.vue').default,
    name: 'all_expiring_orders',
    meta: {requiresAuth: true, title: "All expiring orders", icon: "fas fa-business-time"}
  }, {
    path: '/orders/awaiting_signature', component: require('pages/orders/awaiting_signature.vue').default,
    name: 'orders_awaiting_signature',
    meta: {requiresAuth: true, title: "Unsigned Orders", icon: "fas fa-signature"}
  }, {
    path: '/orders/create', component: require('pages/orders/create.vue').default,
    name: 'create_order',
    meta: {requiresAuth: true, title: "Create Order", icon: "fas fa-clipboard"}
  }, {
    path: 'order/view', component: require('pages/orders/view_order').default,
    name: 'view_order',
    meta: {requiresAuth: true, title: 'View Order', icon: 'fas fa-file-invoice'}
  }, {
    path: 'order/copy', component: require('pages/orders/copy_order').default,
    name: 'copy_order',
    meta: {requiresAuth: true, title: 'Copy Order', icon: 'fas fa-copy'}
  }
];
export default orders;
